module.exports = __webpack_public_path__ + "images/tournamentIcon-b68efc980b7c2aa835ff4eee150978f7.svg";